module.exports = __webpack_public_path__ + "media/images/icons/calendar-9ae023153eb44647df0b722cb9abdec9.svg";